import * as types from "./solicitarBaixaMei.actionTypes";

export default {
  setTokenRecaptcha: data => ({
    type: types.SET_TOKEN_RECAPTCHA,
    payload: data
  }),
  setRecaptchaResetRef: data => ({
    type: types.SET_RECAPTCHA_RESET_REF,
    payload: data
  }),
  pesquisarSolicitarBaixaMei: data => ({
    type: types.PESQUISAR_SOLICITAR_BAIXA_MEI,
    payload: data
  }),
  toggleModalSolicitarBaixaMei: () => ({
    type: types.TOGGLE_MODAL_SOLICITAR_BAIXA_MEI
  }),
  setSolicitarBaixaMei: data => ({
    type: types.SET_SOLICITAR_BAIXA_MEI,
    payload: data
  }),
  selecionarSolicitarBaixaMei: data => ({
    type: types.SOLICITAR_BAIXA_MEI_SELECIONAR,
    payload: data
  }),
  confirmarSenhaSolicitarBaixaMei: data => ({
    type: types.SOLICITAR_BAIXA_MEI_CONFIRMAR_SENHA,
    payload: data
  }),
  processarSolicitarBaixaMei: data => ({
    type: types.SOLICITAR_BAIXA_MEI_PROCESSAR,
    payload: data
  }),
};
